export const messages = {
    "wre-dashboard.nav-menu.item.shared": "Perkongsian",
    "wre-dashboard.nav-menu.item.backups": "Sandaran",
    "wre-dashboard.nav-menu.item.machines": "Mesin",
    "wre-dashboard.nav-menu.item.account": "Akaun",
    "wre-dashboard.search.input.hint": "Carian",
    "wre-dashboard.search.label.breadcrumb": "Keputusan carian",
    "wre-dashboard.search.message.empty": "Item tidak sepadan dengan carian anda",
    "wre-dashboard.side-bar.selected.title:plural": "{count} item dipilih | {count} item dipilih",
    "wre-dashboard.side-bar.backup-type.disk": "Cakera",
    "wre-dashboard.side-bar.backup-type.file": "Fail",
    "wre-dashboard.side-bar.backup-type.notarized": "Folder dan fail diperakui oleh notari",
    "wre-dashboard.side-bar.backup-type.exchange": "Aplikasi - Microsoft Exchange",
    "wre-dashboard.side-bar.backup-type.sql": "Aplikasi - Microsoft SQL",
    "wre-dashboard.side-bar.backup-type.sys-state": "Aplikasi - System state",
    "wre-dashboard.side-bar.backup-type.application": "Aplikasi",
    "wre-dashboard.space-indicator.label.left": "{spaceFree} kiri",
    "wre-dashboard.space-indicator.label.used": "{usedSpace} digunakan",
    "wre-dashboard.space-indicator.label.unlimited": "Tanpa had",
    "wre-dashboard.backups-table.column.name": "Nama",
    "wre-dashboard.backups-table.column.size": "Saiz",
    "wre-dashboard.backups-table.column.version": "Sandaran terakhir",
    "wre-dashboard.backups-table.message.no-backups": "Tiada sandaran lagi dalam Awan",
    "wre-dashboard.backups-sidebar.label.size": "Saiz",
    "wre-dashboard.backups-sidebar.label.type": "Jenis",
    "wre-dashboard.backups-sidebar.label.version": "Versi terakhir",
    "wre-dashboard.backups-sidebar.label.created": "Diciptakan",
    "wre-dashboard.backups-sidebar.label.machine": "Mesin",
    "wre-dashboard.backups-sidebar.label.owner": "Pemilik",
    "wre-dashboard.content-table.column.name": "Nama",
    "wre-dashboard.content-table.column.versions": "Versi",
    "wre-dashboard.content-table.column.volumes": "Isipadu",
    "wre-dashboard.content-table.column.path": "Laluan",
    "wre-dashboard.content-table.column.size": "Saiz",
    "wre-dashboard.content-table.column.version": "Versi terakhir",
    "wre-dashboard.content-table.action.versions": "Versi",
    "wre-dashboard.content-table.action.restore": "Muat turun",
    "wre-dashboard.content-table.action.share": "Kongsi pautan",
    "wre-dashboard.content-table.label.size": "Saiz",
    "wre-dashboard.content-table.label.created": "Diciptakan",
    "wre-dashboard.content-table.label.modified": "Diubah suai",
    "wre-dashboard.content-table.message.empty-folder": "Folder ini kosong",
    "wre-dashboard.password-dialog-box.title.backup": "Sandaran disulitkan",
    "wre-dashboard.password-dialog-box.title.archive": "Arkib disulitkan",
    "wre-dashboard.password-dialog-box.message.backup": "Sila nyatakan kata laluan untuk mengakses sandaran {displayName}",
    "wre-dashboard.password-dialog-box.message.archive": "Sila nyatakan kata laluan untuk mengakses arkib {displayName}",
    "wre-dashboard.password-dialog-box.hint.password": "Kata laluan",
    "wre-dashboard.password-dialog-box.message.invalid-password": "Kata laluan salah",
    "wre-dashboard.form.button.open": "Buka",
    "wre-dashboard.form.button.close": "Tutup",
    "wre-dashboard.form.button.cancel": "Batal",
    "wre-dashboard.form.button.delete": "Hapus",
    "wre-dashboard.shared-content-table.column.name": "Nama",
    "wre-dashboard.shared-content-table.column.location": "Lokasi",
    "wre-dashboard.shared-content-table.column.source": "Sumber",
    "wre-dashboard.shared-content-table.column.days": "Hari",
    "wre-dashboard.shared-content-table.column.downloads": "Muat turun",
    "wre-dashboard.shared-content-table.column.shared": "Dikongsi pada",
    "wre-dashboard.shared-content-table.label.shared": "Dikongsi pada",
    "wre-dashboard.shared-content-table.label.backup": "Sumber",
    "wre-dashboard.shared-content-table.action.share": "Kongsi pautan",
    "wre-dashboard.shared-content-table.action.settings": "Tetapan pautan",
    "wre-dashboard.shared-content-table.action.delete": "Hapuskan pautan",
    "wre-dashboard.shared-content-table.action.delete-selected": "Hapuskan pautan",
    "wre-dashboard.account-page.message.used-space": "{brandName}: {spaceFree} bebas daripada {totalSpace}",
    "wre-dashboard.account-page.message.used-unlimited-space": "{brandName}: Ruang tanpa had",
    "wre-dashboard.account-page.button.sign-out": "Log keluar",
    "wre-dashboard.account-page.button.manage-subscription": "Uruskan lesen",
    "wre-dashboard.account-page.message.subscription.active": "Lesen anda untuk ruang {brandName} tamat tempoh pada",
    "wre-dashboard.account-page.message.subscription.trial": "{brandName} Percubaan aktif sehingga",
    "wre-dashboard.account-page.message.subscription.expired": "Lesen anda untuk ruang {brandName} telah tamat tempoh pada",
    "wre-dashboard.account-page.message.worm-status.storage-full": "Storan {brandName} anda penuh. Anda tidak boleh menyandarkan atau mengarkibkan data ke Awan.",
    "wre-dashboard.account-page.message.worm-status.less-than": "Kurang daripada {percent} peratus kosong. Anda tidak akan boleh menggunakan {brandName} tidak lama lagi.",
    "wre-dashboard.versions-dialog-box.title": "Versi {fileName}",
    "wre-dashboard.shared-link-dialog-box.share-view.button.copy": "Salin pautan",
    "wre-dashboard.shared-link-dialog-box.share-view.button.manage": "Tetapan pautan",
    "wre-dashboard.shared-link-dialog-box.share-view.message": "Sesiapa yang mempunyai pautan ini boleh melihat versi terakhir data",
    "wre-dashboard.shared-link-dialog-box.share-view.label.shared": "Dikongsi pada {creationDate}",
    "wre-dashboard.shared-link-dialog-box.share-view.notification.link-copied": "Pautan disalin",
    "wre-dashboard.shared-link-dialog-box.share-view.notification.link-copy-error": "Ralat Salin Pautan",
    "wre-dashboard.shared-link-dialog-box.delete-view.title": "Hapuskan pautan",
    "wre-dashboard.shared-link-dialog-box.delete-view.message": "Pautan ini tidak lagi akan berfungsi untuk sesiapa yang memilikinya",
    "wre-dashboard.shared-link-dialog-box.delete-selected-view.title": "Hapuskan pautan",
    "wre-dashboard.shared-link-dialog-box.delete-selected-view.message": "Pautan ini akan berhenti berfungsi untuk sesiapa yang mempunyainya",
    "wre-dashboard.shared-link-dialog-box.manage-view.title": "Tetapan pautan",
    "wre-dashboard.shared-link-dialog-box.manage-view.button.delete": "Hapuskan pautan",
    "wre-dashboard.shared-link-dialog-box.manage-view.button.apply": "Selesai",
    "wre-dashboard.shared-link-dialog-box.manage-view.input.hint.password": "Kata laluan",
    "wre-dashboard.shared-link-dialog-box.manage-view.button.reset-password": "Tetapkan semula kata laluan",
    "wre-dashboard.shared-link-dialog-box.manage-view.caption.password-protection": "Perlindungan kata laluan",
    "wre-dashboard.shared-link-dialog-box.manage-view.message.protect-by-password": "Lindungi pautan ini dengan menggunakan kata laluan",
    "wre-dashboard.shared-link-dialog-box.manage-view.caption.expiration": "Tamat tempoh",
    "wre-dashboard.shared-link-dialog-box.manage-view.caption.download-limits": "Had muat turun",
    "wre-dashboard.shared-link-dialog-box.manage-view.label.disable-in:plural": "Nyahdayakan pautan ini dalam {splitMarker} hari | Nyahdayakan pautan ini dalam {splitMarker} hari",
    "wre-dashboard.shared-link-dialog-box.manage-view.label.disable-after:plural": "Nyahdayakan pautan ini selepas {splitMarker} muat turun | Nyahdayakan pautan ini selepas {splitMarker} muat turun",
    "wre-dashboard.sub-accounts-dialog-box.title": "Akaun",
    "wre-dashboard.sub-accounts-dialog-box.search.input.hint": "Carian",
    "wre-dashboard.sub-accounts-dialog-box.table.message.empty": "Item tidak sepadan dengan carian anda",
    "wre-dashboard.sub-accounts-dialog-box.table.column.name": "Nama",
    "wre-dashboard.sub-accounts-dialog-box.table.column.usage": "Penggunaan",
    "wre-dashboard.sub-accounts-dialog-box.table.column.version": "Sandaran terakhir",
    "wre-dashboard.sub-accounts-dialog-box.table.column.expires": "Tamat tempoh",
    "wre-dashboard.sub-accounts-dialog-box.label.used-space": "{spaceFree} bebas daripada {totalSpace}",
    "wre-dashboard.sub-accounts-dialog-box.label.volume-subscription": "Langganan isipadu",
    "wre-dashboard.sub-accounts-dialog-box.label.expired": "Tamat tempoh",
    "wre-dashboard.machines-table.column.name": "Nama",
    "wre-dashboard.machines-table.column.size": "Saiz",
    "wre-dashboard.machines-table.message.no-machines": "Tiada mesin lagi dalam Awan"
};
